import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { CardHeader } from '@components/molecules/CardHeader';
import { Overlay } from '@components/organisms/Overlay';

import * as S from './styles';
import { IProps } from './types';

const Message = ({ title, image, text, content }: IProps) => {
  const modal = useModal();

  return (
    <Overlay position="fit" show={modal.visible} hide={modal.remove}>
      <S.Modal>
        <CardHeader divider formImage={image} onHide={modal.remove}>
          {title}
        </CardHeader>
        {text && <S.Text className="popup-message__text">{text}</S.Text>}
        {content && (
          <S.Content className="popup-message__content">{content}</S.Content>
        )}
      </S.Modal>
    </Overlay>
  );
};

export default NiceModal.create(Message);
